import React from 'react';
import { connect } from 'react-redux';

import Tag from '~/components/Tag';
// import { list2 } from '~/actions/work';
import { available } from '~/actions/work';

import Styles from './widget.scss';

class BoxStatusList extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      works: {}
    };
  }

  componentDidMount() {
    this.fetchInterval = setInterval(this.fetchWork.bind(this), 300000);
    this.fetchWork();
  }

  componentWillReceiveProps(nextProps) {
    const { actionId } = nextProps.indata;
    if (actionId && this.props.indata.actionId !== actionId) {
      this.fetchWork();
    }
  }

  componentWillUnmount() {
    if (this.fetchInterval) {
      clearInterval(this.fetchInterval);
    }
  }

  getWorks() {
    return this.state.works[this.props.indata.actionId];
  }

  fetchWork() {
    this.setState({ loading: true });
    available(this.props.dispatch, this.context.apiClient)
      .then(res => {
        this.setState({
          loading: false,
          works: res.data
        });
      })
      .catch(() => this.setState({ loading: false }));
  }

  render() {
    if (this.state.loading) {
      return <div>Loading boxes...</div>;
    }
    const works = this.getWorks();
    return (
      <div className={`${this.props.className} ${Styles.widget}`}>
        <h5 className={Styles.title}>{this.props.indata.title}</h5>
        <div className={Styles.content}>
          <div>
            {works &&
              (works.length > 40 ? works.slice(0, 40) : works).map(
                (work, i) => {
                  const next = i === 0;
                  const { containerId, orderId } = work;
                  return (
                    <div
                      key={`box_${containerId || orderId}_${i}`}
                      className={`${Styles.boxRow} ${next &&
                        Styles.nextBoxRow}`}
                    >
                      <div className={Styles.comingUp}>
                        {next ? 'Next' : `#${i}`}
                      </div>
                      <div className={Styles.boxInfo}>
                        <span className={Styles.invoiceId}>
                          {orderId && <Tag type="order" id={orderId} />}
                        </span>
                        {containerId && (
                          <div>
                            <Tag type="container" id={containerId} />
                            <span className={Styles.boxCount} />
                          </div>
                        )}
                      </div>
                    </div>
                  );
                }
              )}
            {works && works.length === 0 && 'No boxes.'}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

// Setting pure: false is required for react router to work
export default connect(
  mapStateToProps,
  null,
  null,
  { pure: false }
)(BoxStatusList);



// WEBPACK FOOTER //
// ./app/widgets.new/BoxStatusList/widget.js